import { palette, Text } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

export const ManeuverText = styled(Text)({
  fontSize: '16px',
  fontWeight: 500,
  color: palette.black.main,
  width: '850px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const DottedLine = styled('span')`
  border-left: 2px dotted ${palette.black.plus70};
  position: absolute;
  bottom: -15px;
  height: 15px;
  width: 0;
  background-color: transparent;
  border-left: 3px dotted ${palette.black.plus70};
  left: 6.5px;
`
